<script setup lang="ts">
  import type { TrainingDetailInstructor } from '@/entities/Training';
  import TrainingViewInstructorsList from '../view/TrainingViewInstructorsList.vue';

  defineProps<{
    instructors: TrainingDetailInstructor[];
  }>();
</script>

<template>
  <section
    data-testid="training-control-section-instructors"
    class="flex flex-col gap-4 border-b border-gray-02 px-6 py-8"
  >
    <TrainingViewInstructorsList :instructors="instructors" />
  </section>
</template>
